import { FC, useEffect } from 'react';

import { Outlet } from 'react-router-dom';

import { useAuthLiff } from 'hooks/useAuthLiff';

/**
 * @description
 * LIFF.initで初期化 →
 * ユーザートークン取得 →
 * childrenを表示
 */
export const AuthLiffGuard: FC = () => {
  const { error, actLoginLiff, userToken } = useAuthLiff();

  // ユーザートークンを持っていない場合はliff.initを試行
  useEffect(() => {
    if (!userToken) actLoginLiff();
  }, [userToken, actLoginLiff]);

  // エラー処理
  if (error) return <></>;
  // ローディング
  if (typeof userToken === 'undefined') return <></>;
  // null = エラー
  if (userToken === null) return <></>;

  return <Outlet />;
};
